import { Controller } from "@hotwired/stimulus";
import moment from 'moment';
export default class extends Controller {
  connect() {
    this.searchParams = new URLSearchParams(window.location.search);
    this.initializeTabs();
    this.initializeUnsavedChanges();
    this.initializeChangeHandlers();
    this.initializeAccountKind();
    this.initializeResidentDischarge();
    this.setupPickadate();
    this.setupSubscriptions();
    this.setupCancellationReason();
    this.setupSearchButton();
    this.setupReportingFilter();
    this.setupTooltips();
    this.populateServiceTerm();
    this.populateServiceTermHandler();
  }
  initializeTabs() {
    const activeTab = document.getElementById('organization_tabs');
    if (activeTab){
      activeTab = activeTab.dataset.activeTab;
      document.getElementById(activeTab).classList.add('active');
    }
  }
  initializeUnsavedChanges() {
    const editOrganizationForm = document.querySelector('form.edit_organization');
    if (document.querySelector('.edit_organization')) {
      document.addEventListener('turbo:before-visit', (event) => {
        if (document.querySelector('.edit_organization') && editOrganizationForm.dataset.changed) {
          if (!confirm('There are unsaved changes, click "Cancel" to remain on the page.')) {
            event.preventDefault();
          }
        }
      });
    }
  }
  initializeChangeHandlers() {
    const editOrganizationInputs = document.querySelectorAll('form.edit_organization input');
    const editOrganizationSelects = document.querySelectorAll('form.edit_organization select');
    editOrganizationInputs.forEach((input) => {
      input.addEventListener('change', () => {
        this.setFormChanged(true);
      });
    });
    editOrganizationSelects.forEach((select) => {
      select.addEventListener('change', () => {
        this.setFormChanged(true);
      });
    });
    const editOrganizationForm = document.querySelector('form.edit_organization');
    if (editOrganizationForm) {
      editOrganizationForm.addEventListener('submit', () => {
        this.setFormChanged(false);
      });
    }
  }
  setFormChanged(value) {
    const editOrganizationForm = document.querySelector('form.edit_organization');
    editOrganizationForm.dataset.changed = value;
  }
  initializeAccountKind() {
    const accountKind = document.querySelectorAll('.account_kind');
    accountKind.forEach((kind) => {
      kind.addEventListener('change', () => {
        const servicesIds = ['messages', 'alumni_engagement', 'outcomes', 'provider_management_software', 'resident_app', 'location_services', 'calendars', 'forms'];
        let shouldDisable = !document.querySelector('#kind_sober_home').checked;
        let affiliate_kind_checked = document.querySelector('#kind_affiliate').checked;
        let affiliateExculsiveServices = ['members'];
        if (!shouldDisable) {
          servicesIds.push('medical_logs', 'crm', 'money_log', 'payments', 'ua_ba', 'online_presence');
        }
        if (affiliate_kind_checked && shouldDisable) {
          const servicesDiv = document.getElementById('services');
          const inputElements = servicesDiv.getElementsByTagName('input');
          for (let i = 0; i < inputElements.length; i++) {
            servicesIds.push(inputElements[i].name.split('[')[0]);
          }
          var affiliate_kind_servicesIds = ['forms', 'team_folder', 'agenda', 'members', 'outcomes'];
        }
        servicesIds.forEach((service) => {
          const serviceId = `#${service}_status`;
          if (document.querySelector(serviceId)) {
            document.querySelector(serviceId).checked = !shouldDisable;
          }
        });

        if (affiliate_kind_checked && shouldDisable) {
                    affiliate_kind_servicesIds.forEach((service) => {
            const serviceId = `#${service}_status`;
            document.querySelector(serviceId).checked = true;
          });
        }

        if (!affiliate_kind_checked){
          affiliateExculsiveServices.forEach((service) => {
            const serviceId = `#${service}_status`;
            $(`${serviceId}`).closest('.align-items-center').removeClass('d-flex');
            $(`${serviceId}`).closest('.align-items-center').hide();
          })
        }
        else {
          affiliateExculsiveServices.forEach((service) => {
            const serviceId = `#${service}_status`;
            $(`${serviceId}`).closest('.align-items-center').addClass('d-flex');
            $(`${serviceId}`).closest('.align-items-center').removeClass('hide_member_service');
            $(`${serviceId}`).closest('.align-items-center').show();
          })
        }
      });
    });
  }
  initializeResidentDischarge() {
    const residentIdInput = document.querySelector('.resident_discharge #resident_id');
    if (residentIdInput) {
      residentIdInput.addEventListener('change', () => {
        const residentId = document.getElementById('resident_id').value;
        if (this.searchParams.get('resident_id') !== residentId) {
          window.location.replace(`${window.location.href.split('?')[0]}?resident_id=${residentId}`);
        }
      });
    }
  }
  setupPickadate() {
    const pickadateDefaults = {
      format: "mm/dd/yyyy",
      formatSubmit: "yyyy/mm/dd",
      hiddenName: true,
      selectYears: 200,
      selectMonths: true,
    };

    const pickadateInputs = this.element.querySelectorAll(".resident_discharge .pickadate");
    pickadateInputs.forEach((input) => {
      $(input).pickadate(pickadateDefaults);
    });
  }

  setupSubscriptions() {
    const subscriptionsArray =  JSON.parse(this.element.dataset.subscriptions);
    if (subscriptionsArray) {
      subscriptionsArray.forEach((sub) => {
        const subStatus = this.element.querySelector(`#${sub.name}_status.service_status_input`);
        const subPaymentAmount = this.element.querySelector(`#${sub.name}_payment_amount`);
        subStatus.checked = sub.status;
        if (subPaymentAmount) {
          subPaymentAmount.value = parseFloat(sub.payment_amount).toFixed(2);
          if (subStatus.checked) {
            subPaymentAmount.classList.remove("d-none");
          } else {
            subPaymentAmount.classList.add("d-none");
          }
        }
      });
    }
  }

  setupCancellationReason() {
    const cancellationReason = this.element.querySelector("#organization_cancelation_attributes_reason");

    if (cancellationReason) {
      const reasonChangeHandler = () => {
        const reason = cancellationReason.value;
        const cancellationCompetitor = this.element.querySelector("#cancelation-competitor");
        const cancellationMissingFeatures = this.element.querySelector("#cancelation-missing-features");
        const missingFeaturesTextarea = this.element.querySelector("#cancelation-missing-features textarea");

        if (reason === "Switching to Competitor") {
          cancellationCompetitor.classList.remove("d-none");
          cancellationMissingFeatures.classList.add("d-none");
          missingFeaturesTextarea.value = "";
        } else if (reason === "Missing Feature") {
          cancellationCompetitor.classList.add("d-none");
          cancellationMissingFeatures.classList.remove("d-none");
          this.element.querySelector("#cancelation-competitor select").value = "";
        }
      };

      cancellationReason.addEventListener("change", reasonChangeHandler);
    }
  }

  setupSearchButton() {
    const searchButton = this.element.querySelector("button.r-ez-search");
    if (searchButton) {
      searchButton.addEventListener("click", () => {
        const searchType = searchButton.dataset.search;
        const qrChargesPaidAtGteq = this.element.querySelector("#qr_charges_paid_at_gteq");
        const qrChargesPaidAtEndOfDayLteq = this.element.querySelector("#qr_charges_paid_at_end_of_day_lteq");
        const today = moment().format("YYYY-MM-DD");

        switch (searchType) {
          case "ytd":
            qrChargesPaidAtGteq.value = moment().startOf("year").format("YYYY-MM-DD");
            break;
          case "mtd":
            qrChargesPaidAtGteq.value = moment().startOf("month").format("YYYY-MM-DD");
            break;
          case "daily":
            qrChargesPaidAtGteq.value = moment().format("YYYY-MM-DD");
            break;
        }

        qrChargesPaidAtEndOfDayLteq.value = today;
        this.element.querySelector("#resident_search").submit();
      });
    }
  }

  setupReportingFilter() {
    const reportingFilters = this.element.querySelectorAll("#organization_reporting .reporting-filter");
    reportingFilters.forEach((filter) => {
      if (filter.href === location.href) {
        filter.classList.add("active");
      }
    });
  }

  setupTooltips() {
    const tooltips = this.element.querySelectorAll('[data-toggle="tooltip"]');
    tooltips.forEach((tooltip) => {
      tooltip.tooltip();
    });
  }

  disposeTooltips() {
    const tooltips = this.element.querySelectorAll('[data-toggle="tooltip"]');
    tooltips.forEach((tooltip) => {
      tooltip.tooltip("dispose");
    });
  }

  populateServiceTerm() {
    const payment = document.querySelector('#organization_payment');
    const paymentType = document.querySelector('#organization_payment_type');
    if (payment && paymentType) {

      const serviceTerm = `The initial term of this Agreement shall be ${payment.value} $ (USD) (the “Initial Term”). \
      At the end of the Initial Term, this Agreement will automatically renew ${paymentType.value} (the “Renewal Term”). \
      The Initial Term together with the Renewal Term is the (“Service Term.”).
      Method of Payment: Customer shall pay One Step for the Initial Term on the Effective Date of this Agreement. \
      Customer shall pay subsequent ${paymentType.value} payments upon receipt of the invoice. If the number of houses \
      changes at any time, the Customer will be billed an additional ${payment.value} $ (USD) for each house added. \
      Customer may cancel their subscription to One Step by providing 30 days notice.`;

      document.querySelector('#organization_service_term').value = serviceTerm;
    }
  }

  populateServiceTermHandler() {
    document.querySelectorAll('form.simple_form.edit_organization input, form.simple_form.new_organization input:not(#organization_service_term)').forEach((input) => {
      input.addEventListener('keyup', () => {
        this.populateServiceTerm();
      });

      input.addEventListener('change', () => {
        this.populateServiceTerm();
      });
    });
  }

}
